import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "coh00100-history-table" }
const _hoisted_2 = { class: "row items-center q-ma-none" }
const _hoisted_3 = { class: "row items-center justify-end" }
const _hoisted_4 = { class: "row items-center justify-end" }
const _hoisted_5 = { class: "row justify-end q-gutter-x-xs" }
const _hoisted_6 = { class: "row coh00100-result-table" }
const _hoisted_7 = { class: "full-width row q-gutter-sm" }
const _hoisted_8 = { class: "q-pt-xs" }

import { ref } from 'vue';
import Loading from 'quasar/src/plugins/Loading.js';;
import { useRouter } from 'vue-router';
import saveAs from 'file-saver';
import http from '../common/axios-common';
import HttpResponseStatusCode from '../common/code/HttpResponseStatusCode';
import base64toBlob from '../common/utils/fileUtils';
import PageHeaderBanner from '../components/banner/PageHeaderBanner.vue';
import AlertDialog from '../components/dialogs/AlertDialog.vue';

// 検索結果
interface Result {
  requestTimestamp: string;
  requestId: string;
  requestType: string;
  requestCustomerCode: string | null;
  requestCustomerName: string | null;
  requestUserMailAddress: string;
  requestUserName: string;
  requestCount: number;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'COH00100',
  setup(__props) {

const router = useRouter();

// 取得したデータ
const data = ref<Array<Result>>([]);

// 表示するデータ
const rows = ref<Array<Result>>(data.value);

// 検索条件：from
const startDate = ref('');

// 検索条件：to
const endDate = ref('');

// Dialogタイトル
const dialogTitle = ref('');

// Dialog表示レベル
const dialogLevel = ref('');

// Dialog本文
const dialogText = ref(['']);

// 確認Dialogフラグ
const isConfFlg = ref(false);

// Excel出力確認Dialog表示フラグ
const isOutExcelDialog = ref(false);

// 初期表示読み込み時「データがありません」を非表示にするためのフラグ(falseで表示)
const hideNoDataFlg = ref(true);

// Excelファイル出力の検索条件:from
const from = ref('');

// Excelファイル出力の検索条件:to
const to = ref('');

// クリアボタン処理
const clear = () => {
  startDate.value = '';
  endDate.value = '';
};

// カラム
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const columns: Array<any> = [
  {
    name: 'requestTimestamp',
    label: '依頼日時',
    align: 'left',
    field: 'requestTimestamp',
    sortable: true,
    style: 'width: 120px',
  },
  {
    name: 'requestId',
    label: '依頼No.',
    align: 'left',
    field: 'requestId',
    sortable: true,
  },
  {
    name: 'requestType',
    label: '依頼区分',
    align: 'left',
    field: 'requestType',
    sortable: true,
    style: 'width: 40px',
  },
  {
    name: 'requestCustomerCode',
    label: '得意先コード',
    align: 'left',
    field: 'requestCustomerCode',
    sortable: true,
    style: 'width: 110px',
  },
  {
    name: 'requestCustomerName',
    label: '得意先名｜納品場所',
    align: 'left',
    field: 'requestCustomerName',
    sortable: true,
  },
  {
    name: 'requestMailAddress',
    label: '会員ID（メールアドレス）',
    align: 'left',
    field: 'requestMailAddress',
    sortable: true,
  },
  {
    name: 'requestUserName',
    label: '会員名',
    align: 'left',
    field: 'requestUserName',
    sortable: true,
  },
  {
    name: 'requestCount',
    label: '件数',
    align: 'left',
    classes: 'text-right',
    field: 'requestCount',
    sortable: true,
  },
];

/**
 * Excel出力確認ダイアログ表示
 */
const displayOutExcelDialog = () => {
  isOutExcelDialog.value = true;
  dialogTitle.value = 'Excel出力確認';
  dialogLevel.value = 'information';
  dialogText.value = ['注文・見積依頼履歴のExcelファイルを出力します。', 'よろしいですか？'];
  isConfFlg.value = false;
};

// startDateの値とendDateの値が互いの値により制御されるメソッド
const optionsStart = (stDate: string) => {
  if (endDate.value) {
    return stDate <= endDate.value && stDate >= '1999/01/01';
  }
  return stDate <= '2999/12/31' && stDate >= '1999/01/01';
};
const optionsEnd = (edDate: string) => edDate >= startDate.value && edDate <= '2999/12/31';

// 注文・見積依頼履歴取得
const getRequestHistory = () => {
  // Loading Start
  Loading.show();
  http
    .post('/coh001001/requestHistory')
    .then((response) => {
      data.value = response.data.historyList;
      rows.value = data.value;
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        //  エラー画面に遷移
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
      hideNoDataFlg.value = false;
    });
};

// 注文・見積依頼履歴日付絞り込み検索
const search = () => {
  // Loading Start
  Loading.show();
  from.value = startDate.value;
  to.value = endDate.value;
  const formData = new FormData();
  formData.append('startDate', startDate.value);
  formData.append('endDate', endDate.value);
  http
    .post('/coh001001/requestHistory', formData)
    .then((response) => {
      data.value = response.data.historyList;
      rows.value = data.value;
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他のエラーの場合
        //  エラー画面に遷移
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

// Excel出力
const download = () => {
  // Loading Start
  Loading.show();

  const formData = new FormData();
  formData.append('startDate', from.value);
  formData.append('endDate', to.value);
  http
    .post('/coh001001/downloadHistory', formData)
    .then((response) => {
      const blob = new Blob(
        [
          base64toBlob(
            response.data.body,
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          ),
        ],
        {}
      );
      saveAs(blob, response.data.file_name);
      // ダイアログ表示
      dialogTitle.value = 'Excel出力完了';
      dialogLevel.value = 'information';
      dialogText.value = ['注文・見積依頼履歴のExcelファイルを出力しました。'];
      isConfFlg.value = true;
      isOutExcelDialog.value = true;
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他のエラーの場合
        //  エラー画面に遷移
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

// 初期表示
getRequestHistory();

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_date = _resolveComponent("q-date")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_table = _resolveComponent("q-table")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PageHeaderBanner, null, {
      title: _withCtx(() => _cache[6] || (_cache[6] = [
        _createTextVNode("注文・見積依頼履歴")
      ])),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_q_card, {
        style: {"background":"var(--q-lightGray)"},
        flat: "",
        bordered: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "q-gutter-y-sm" }, {
            default: _withCtx(() => [
              _cache[8] || (_cache[8] = _createElementVNode("label", null, "期間", -1)),
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_q_input, {
                  modelValue: startDate.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((startDate).value = $event)),
                  outlined: "",
                  dense: "",
                  mask: "date",
                  class: "date q-pb-none q-mr-sm",
                  style: {"width":"140px"},
                  readonly: ""
                }, {
                  append: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: "event",
                      class: "cursor-pointer"
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_q_popup_proxy, {
                      cover: "",
                      "transition-show": "scale",
                      "transition-hide": "scale"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_date, {
                          modelValue: startDate.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((startDate).value = $event)),
                          minimal: "",
                          options: optionsStart
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, [
                              _withDirectives(_createVNode(_component_q_btn, {
                                label: "OK",
                                color: "primary",
                                flat: ""
                              }, null, 512), [
                                [_directive_close_popup]
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _cache[7] || (_cache[7] = _createElementVNode("label", { class: "q-mr-sm" }, " 〜 ", -1)),
                _createVNode(_component_q_input, {
                  modelValue: endDate.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((endDate).value = $event)),
                  outlined: "",
                  dense: "",
                  mask: "date",
                  class: "q-pb-none q-mr-sm",
                  style: {"width":"140px"},
                  readonly: ""
                }, {
                  append: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: "event",
                      class: "cursor-pointer"
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_q_popup_proxy, {
                      cover: "",
                      "transition-show": "scale",
                      "transition-hide": "scale"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_date, {
                          modelValue: endDate.value,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((endDate).value = $event)),
                          minimal: "",
                          options: optionsEnd
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_4, [
                              _withDirectives(_createVNode(_component_q_btn, {
                                label: "OK",
                                color: "primary",
                                flat: ""
                              }, null, 512), [
                                [_directive_close_popup]
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_q_btn, {
                  icon: "mdi-magnify",
                  label: "検索",
                  color: "primary",
                  style: {"width":"150px","padding-left":"0","padding-right":"0"},
                  onClick: search
                }),
                _createVNode(_component_q_btn, {
                  outline: "",
                  style: {"width":"150px","background":"var(--q-white) !important","color":"var(--q-delete)","padding-left":"0","padding-right":"0"},
                  icon: "mdi-eraser",
                  label: "クリア",
                  onClick: clear
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: _normalizeClass('chem-table-area nofixed-column ' + (rows.value.length === 0 ? 'table-nodata' : '')),
          style: {"width":"100%"}
        }, [
          _createVNode(_component_q_table, {
            class: "my-sticky-header-column-order-table",
            rows: rows.value,
            columns: columns,
            "row-key": "index",
            flat: "",
            dense: "",
            separator: "cell",
            "hide-no-data": hideNoDataFlg.value,
            "no-data-label": "データがありません。",
            "rows-per-page-options": [10, 20, 50, 0],
            "rows-per-page-label": "件表示",
            "pagination-label": 
              (firstRowIndex, endRowIndex, totalRowsNumber) => {
                return `${totalRowsNumber} 件中 ${firstRowIndex}～${endRowIndex} 件表示`;
              }
            
          }, {
            "no-data": _withCtx(({ message }) => [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_q_icon, {
                  size: "24px",
                  name: "mdi-alert-circle-outline"
                }),
                _createElementVNode("span", _hoisted_8, _toDisplayString(message), 1)
              ])
            ]),
            top: _withCtx(() => [
              _createVNode(_component_q_btn, {
                color: "primary",
                class: _normalizeClass(
                  'export-btn excel-exportbtn ' + (rows.value.length === 0 ? 'coh00100-disabled-btn' : '')
                ),
                outline: data.value.length !== 0 ? true : false,
                icon: "mdi-download",
                "no-caps": "",
                disable: rows.value.length === 0,
                onClick: displayOutExcelDialog
              }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createTextVNode("Excel出力")
                ])),
                _: 1
              }, 8, ["class", "outline", "disable"]),
              (rows.value.length === 0)
                ? (_openBlock(), _createBlock(_component_q_tooltip, {
                    key: 0,
                    anchor: "top right",
                    offset: [-70, 8],
                    self: "bottom middle"
                  }, {
                    default: _withCtx(() => _cache[10] || (_cache[10] = [
                      _createElementVNode("strong", null, "検索結果が存在しません。", -1)
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["rows", "hide-no-data", "pagination-label"])
        ], 2)
      ])
    ]),
    _createVNode(AlertDialog, {
      display: isOutExcelDialog.value,
      level: dialogLevel.value,
      confirmation: isConfFlg.value,
      title: dialogTitle.value,
      text: dialogText.value,
      onComplete: _cache[4] || (_cache[4] = ($event: any) => (isOutExcelDialog.value = false)),
      onConfirm: download,
      onClose: _cache[5] || (_cache[5] = ($event: any) => (isOutExcelDialog.value = false))
    }, null, 8, ["display", "level", "confirmation", "title", "text"])
  ]))
}
}

})